import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import ReportingFilterBox from './ReportingFilterBox';
import ReportingFilterSearchParams from '../ReportingFilterSearchParams';
import InfoBoxForPlanning from '../InfoBoxForPlanning';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import PlanningDetailsForReportingItem from '../../../Domain/PlanningDetailsForReportingItem';
import ExportReport from './ExportReport';
import ErrorMessage from '../../../Elements/ErrorMessage';
import Loading from '../../../Elements/loading';
import AcceleratedDataTable from '../../../Elements/DataTable/AcceleratedDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import orderByHelper from '../../../Helpers/orderByHelper';

class Reporting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shownPanel: ShownPanelsEnum.Search,
      filter: new ReportingFilterSearchParams(),
      planningDetailItems: [],
      loading: false,
      exportLoading: false,
      orderBy: 'PlanningDetailId',
      orderDirection: OrderDirectionsEnum.Asc,
    };
    this.panelClickOnCancel = this.panelClickOnCancel.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.startExport = this.startExport.bind(this);
  }

  componentDidMount() {
    // this.setState({loading:true});
    // this.populatePlanningItemDetailsData(this.state.filter,this.state.orderBy,this.state.orderDirection);
  }

  changeOrderBy(orderById) {
    if (['plannedrevenue', 'realizedrevenue', 'invoicedrevenue'].includes(orderById)) {
      ErrorMessage.SetNotification('The money values have been grouped by their currencies.');
    }

    const newOrderByDirection = orderByHelper.newOrderByDirection(
      this.state.orderBy,
      orderById,
      this.state.orderDirection
    );
    this.setState(
      {
        orderBy: orderById,
        orderDirection: newOrderByDirection,
      },
      () => this.populatePlanningItemDetailsData(this.state.filter, this.state.orderBy, this.state.orderDirection)
    );
  }

  async populatePlanningItemDetailsData(filter, orderBy, orderDirection) {
    this.setState({ loading: true });
    PlanningDetailsItemService.GetPlanningDetailsItemsWithFilter({ ...filter }, orderBy, orderDirection)
      .then((result) => {
        this.setState({
          planningDetailItems: PlanningDetailsItemService.ConvertDBPlanningDetailsForReportingItems(result),
          loading: false,
        });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! Errorcode: RP55');
        this.setState({ loading: false });
      });
  }

  panelClickOnCancel() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  startSearch(filter) {
    this.setState({
      filter,
      loading: true,
      shownPanel: ShownPanelsEnum.None,
    });
    this.populatePlanningItemDetailsData(filter, this.state.orderBy, this.state.orderDirection);
  }

  showPanel(key) {
    if (key === ShownPanelsEnum.Refresh) {
      this.populatePlanningItemDetailsData(this.state.filter, this.state.orderBy, this.state.orderDirection);
      key = ShownPanelsEnum.None;
    }
    if (key === this.state.shownPanel) {
      key = ShownPanelsEnum.None;
    }
    this.setState({ shownPanel: key });
  }

  startExport(filter) {
    this.setState(
      { exportLoading: true },
      ExportReport.SaveAsExcel(filter, 'PlanningFWReport', () => this.setState({ exportLoading: false }))
    );
  }

  renderButtonRow() {
    return (
      <>
        <ButtonRow
          labels={['Refresh', 'Filter']}
          keys={[ShownPanelsEnum.Refresh, ShownPanelsEnum.Search]}
          icons={['fa-solid fa-refresh', 'fa-solid fa-mug-hot']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
      </>
    );
  }

  renderFilteringPanel() {
    if (this.state.shownPanel === ShownPanelsEnum.Search) {
      return (
        <>
          {/* <GeneralSearchStrip
					searchItem={this.state.filter}
					searchparamsType={ReportingFilterSearchParams}
					clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
					clickOnOk={this.startSearch}
                    exportFunction={this.startExport}
				/> */}
          <ReportingFilterBox
            panelClickOnCancel={this.panelClickOnCancel}
            filter={this.state.filter}
            startSearch={this.startSearch}
            exportLoading={this.state.exportLoading}
            screenLoading={this.state.loading}
            startExport={this.startExport}
          />
        </>
      );
    }
    return null;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonRow()}
        {this.renderFilteringPanel()}
        {this.state.loading ? (
          <Loading />
        ) : (
          <AcceleratedDataTable
            itemList={this.state.planningDetailItems}
            orderBy={this.state.orderBy}
            orderDirection={this.state.orderDirection}
            changeOrderBy={(orderById) => this.changeOrderBy(orderById)}
            type={PlanningDetailsForReportingItem}
            selectable={this.state.shownPanel === ShownPanelsEnum.None}
            thereIsNoSuchRowMessage={`Click on the "View Report on Screen" button to show the report.`}
          />
        )}
        <InfoBoxForPlanning />
      </div>
    );
  }
}

export default Reporting;
